module.exports = __webpack_public_path__ + "img/sidebar-2.a66ca4a2.jpg";